
qx.Class.define('cv.Version', {
  type: 'static',

  statics: {
    REV: '1e5b2433d9234308561a7cfdda4590a1044440ef',
    BRANCH: 'master',
    VERSION: '0.12.6',
    LIBRARY_VERSION: 9,
    DATE: '2024-11-18T16:21:03.118Z',
    TAGS: { 
      RUNTIME: 'demo'
    }
  }
});    
